/* eslint-disable no-restricted-imports */
import React from "react";

import { Snackbar } from "@material-ui/core";

import { Alert } from "../Alert";

import { useStyles } from "./AlertMessage.styles";

export const AlertMessage = ({
  message,
  handleClose,
  open,
  severity = "success",
}) => {
  const classes = useStyles();

  const vertical = "top";

  const horizontal = "center";

  return (
    <div className={classes.root}>
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};
